export enum UrovenSystemovehoZaznamu {
	INFO = 'INFO',
	CHYBA = 'CHYBA'
}
